// Module
var code = "<template> <require from=\"./toast-header.scss\"></require> <slot></slot> </template> ";
// Exports
module.exports = code;